/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Embed_Captions_File_Size_GbInputs */



/**
* | output |
* | --- |
* | "({size} GB)" |
*
* @param {Embed_Captions_File_Size_GbInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_file_size_gb = /** @type {((inputs: Embed_Captions_File_Size_GbInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_File_Size_GbInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`(${i?.size} Go)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`（${i?.size} GB）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`（${i?.size} GB）`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`(${i?.size} जीबी)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
	return /** @type {LocalizedString} */ (`(${i?.size} GB)`)
});